/**
 * `tagList` — normaliza las etiquetas de un CI a un array de cadenas.
 *
 * POR QUÉ EXISTE
 * ---------------------------------------------------------------------------
 * Los modelos NO guardan las etiquetas igual, y `to_dict` los devuelve tal cual:
 *   · `Service.tags`   → columna de texto con un CSV: «producción, erp».
 *   · `VirtVM.tags`    → columna JSON: ya es un array.
 *   · `RackElement`    → puede llegar de las dos formas según el registro.
 *
 * Por eso hacer `(x.tags || []).join()` o `.length` directamente funciona con
 * unos y revienta con otros («(s.tags || []).join is not a function» es
 * exactamente ese fallo). Todo lo que pinte, cuente o exporte etiquetas pasa
 * por aquí: nunca se asume que el campo ya es un array.
 */
export function tagList(value) {
  if (Array.isArray(value)) {
    return value.map(v => String(v).trim()).filter(Boolean);
  }
  if (typeof value === 'string') {
    return value.split(',').map(v => v.trim()).filter(Boolean);
  }
  return [];
}

export default tagList;
